import { branch, compose, renderNothing } from 'recompose';

import PaymentModalReedemCode from '../components/PaymenModalReedemCode';
import sharedContainer from './ReedemCodeSharedContainer';
import WithTimeWaitingList from '../../hoc/WithTimeWaitingList';

export default compose(
  WithTimeWaitingList,
  branch(
    props => props.timeWaitingList,
    renderNothing,
  ),
  sharedContainer,
)(PaymentModalReedemCode);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/PaymentModalReedemCode.js